import type { CSSProperties } from 'react';

export function Skeleton({ variant = 'text', style }: { variant?: 'text' | 'row'; style?: CSSProperties }) {
  return <div className={`skeleton skeleton--${variant}`} style={style} aria-hidden="true" />;
}
